export default "__VITE_ASSET__b7e1fd87__"